<template>
  <div class="time-scale">
    <div
      class="current-tick"
      :style="{ transform: `translateY(${tickOffset}px)` }"
    ></div>
    <div
      v-for="(minutes, idx) in marks"
      :key="idx"
      class="time-mark"
      :class="tickType(minutes)"
      :style="{ height: `${getMarkHeight()}px` }"
    >
      <!-- Сам штрих: теперь он позиционируется справа -->
      <div class="tick"></div>

      <!-- Подпись времени выводим для каждого 15-минутного шага -->
      <span class="time-label">{{ formatTime(minutes) }}</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'TimeScale',
  props: {
    marks: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      currentMinutes: 0,
      timer: null,
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    cellInterval() {
      return this.user.cell_interval ?? 15;
    },
    tickOffset() {
      // Высота одного интервала в пикселях (32px за 15 минут)
      const pixelsPerMinute = 32 / this.cellInterval;
      return this.currentMinutes * pixelsPerMinute;
    }
  },
  mounted() {
    this.updateCurrentMinutes();
    this.timer = setInterval(this.updateCurrentMinutes, 60000);
  },
  beforeUnmount() {
    clearInterval(this.timer);
  },
  methods: {
    // Преобразуем минуты в строку “HH:MM”
    formatTime(totalMinutes) {
      const h = Math.floor(totalMinutes / 60)
      const m = totalMinutes % 60
      const hh = String(h).padStart(2, '0')
      const mm = String(m).padStart(2, '0')
      return `${hh}:${mm}`
    },
    // Определяем тип штриха (“hour”, “half” или “quarter”)
    tickType(totalMinutes) {
      if (totalMinutes % 60 === 0) {
        return 'mark-hour'
      } else if (totalMinutes % 30 === 0) {
        return 'mark-half'
      } else {
        return 'mark-quarter'
      }
    },
    getMarkHeight() {
      return 32 * (this.cellInterval / 15);
    },
    updateCurrentMinutes() {
      const now = new Date();
      this.currentMinutes = now.getHours() * 60 + now.getMinutes();
    }
  }
}
</script>

<style scoped>
/* Основной контейнер: ширина 80px, фон и граница */
.time-scale {
  width: 80px;
  background: #fafafa;
  border-right: 1px solid #e0e0e0;
  /* Добавь box-sizing! */
  box-sizing: border-box;
  margin-top: -16px;
  padding-bottom: 16px;
}

/* Каждый «рядышком» блок занимает 32px высоты */
.time-mark {
  position: relative;
  height: 32px; /* 15 минут = 32px */
  display: flex;
  align-items: center; /* вертикальное выравнивание контента внутри */
}

/* ------------ ШТРИХИ (TICK) ------------ */

/* Общие стили для штриха: абсолютное позиционирование справа */
.tick {
  position: absolute;
  right: 0; /* штрих уходит к правому краю колонки */
  /* высота 2px или 1px задаём в конкретных классах */
  background-color: transparent;
}

/* ЧАСОВОЙ штрих (например, 09:00): ширина 32px, толщина 2px, чёрный */
.mark-hour .tick {
  width: 32px;
  height: 2px;
  background-color: #000;
}

/* ПОЛУчасовой штрих (например, 09:30): ширина 24px, толщина 1px, темно-серый */
.mark-half .tick {
  width: 24px;
  height: 1px;
  background-color: #555;
}

/* ЧЕТВЕРТНОЙ штрих (например, 09:15/09:45): ширина 16px, толщина 1px, светло-серый */
.mark-quarter .tick {
  width: 16px;
  height: 1px;
  background-color: #aaa;
}

/* ------------ ПОДПИСИ (TIME LABEL) ------------ */

/* Общие стили для подписи времени */
.time-label {
  position: absolute;
  right: 36px; /* смещаем влево от штриха (32px + небольшой отступ) */
  white-space: nowrap;
}

/* ЧАС (09:00): крупный жирный шрифт, чёрный */
.mark-hour .time-label {
  font-size: 14px;
  font-weight: 600;
  color: #000;
  line-height: 32px; /* чтобы выравнять подпись по вертикали */
}

/* ПОЛУЧАС (09:30): чуть меньше, полужирный, темно-серый */
.mark-half .time-label {
  font-size: 13px;
  font-weight: 500;
  color: #555;
  line-height: 32px;
}

/* ЧЕТВЕРТ (09:15/09:45): самый мелкий, тонкий, бледно-серый */
.mark-quarter .time-label {
  font-size: 11px;
  font-weight: 400;
  color: #999;
  line-height: 32px;
}
</style>

.current-tick {
  position: absolute;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #ff6b00;
  z-index: 10;
  transition: transform 0.3s linear;
}
